import { formatCurrency, formatDateWithOptionsBs } from "@/lib/format";
import { formatLocalYmd } from "@/lib/company-expiry";
import { formatCoveredRange, invoiceCoveredRange, type InvoicePeriodInput } from "@/lib/company-invoices/period";
import type { CompanyInvoiceSummary } from "@/types";

export const fmtKm = (n: number) => formatCurrency(n);

const SHORT = { timeZone: "Europe/Sarajevo", day: "numeric", month: "short", year: "numeric" } as const;

/**
 * "oktobar 2026." za mjesečnu fakturu bez zakašnjelih stavki; inače stvarno
 * obuhvaćen raspon ("20. sep 2026. - 31. okt 2026."), kao na PDF-u. Faktura za
 * dopunu kredita nema period, prikazuje se datum dopune.
 */
export function invoicePeriodLabel(inv: InvoicePeriodInput): string {
  if (inv.kind === "credit_topup") {
    return `Dopuna kredita, ${formatDateWithOptionsBs(invoiceCoveredRange(inv).from, SHORT)}`;
  }
  if (inv.kind === "monthly" && invoiceCoveredRange(inv).from === inv.periodStart) {
    return formatDateWithOptionsBs(inv.periodStart, { timeZone: "Europe/Sarajevo", month: "long", year: "numeric" });
  }
  return formatCoveredRange(inv, (iso) => formatDateWithOptionsBs(iso, SHORT));
}

export function invoiceDisplayStatus(inv: Pick<CompanyInvoiceSummary, "status" | "dueAt">, today: string) {
  return inv.status === "issued" && inv.dueAt && inv.dueAt < today ? "overdue" : inv.status;
}

export const dueLabel = (dueAt: string | null) => (dueAt ? formatLocalYmd(dueAt) : "");
